import { apiClient } from './auth.service'

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000'

export const notificationsService = {
  async getAll(params = {}) {
    const queryParams = new URLSearchParams()
    if (params.is_read !== undefined) queryParams.append('is_read', params.is_read)
    if (params.type) queryParams.append('type', params.type)
    if (params.limit) queryParams.append('limit', params.limit)
    if (params.offset) queryParams.append('offset', params.offset)

    const response = await apiClient.get(`${API_URL}/notifications?${queryParams}`)
    return response.data
  },

  async getNotificationTypes() {
    const response = await apiClient.get(`${API_URL}/notifications/types`)
    return response.data
  },

  async getUnreadCount() {
    const response = await apiClient.get(`${API_URL}/notifications/unread-count`)
    return response.data
  },

  async getById(id) {
    const response = await apiClient.get(`${API_URL}/notifications/${id}`)
    return response.data
  },

  async markAsRead(id) {
    const response = await apiClient.patch(`${API_URL}/notifications/${id}/read`)
    return response.data
  },

  async markAsUnread(id) {
    const response = await apiClient.patch(`${API_URL}/notifications/${id}/unread`)
    return response.data
  },

  async markAllAsRead() {
    const response = await apiClient.patch(`${API_URL}/notifications/read-all`)
    return response.data
  },

  async delete(id) {
    const response = await apiClient.delete(`${API_URL}/notifications/${id}`)
    return response.data
  },

  async create(data) {
    const response = await apiClient.post(`${API_URL}/notifications`, data)
    return response.data
  },
}
